<style type="text/css">
.rr-controller.svelte-1cgfpn0 {
    width: 100%;
    height: 80px;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    border-radius: 0 0 5px 5px;
}

.rr-timeline.svelte-1cgfpn0 {
    width: 80%;
    display: flex;
    align-items: center;
}

.rr-timeline__time.svelte-1cgfpn0 {
    padding: 0 20px;
    color: #11103e;
}

.rr-progress.svelte-1cgfpn0 {
    width: 100%;
    height: 12px;
    background: #eee;
    position: relative;
    border-radius: 3px;
    cursor: pointer;
    box-sizing: border-box;
    border-top: solid 4px #fff;
    border-bottom: solid 4px #fff;
}

.rr-progress__step.svelte-1cgfpn0 {
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: #e0e1fe;
}

.rr-progress__handler.svelte-1cgfpn0 {
    width: 20px;
    height: 20px;
    border-radius: 10px;
    position: absolute;
    top: 2px;
    transform: translate(-50%, -50%);
    background: rgb(73, 80, 246);
}

.rr-timeline__time.svelte-1cgfpn0 {
    padding: 0 20px;
    color: #11103e;
}

.rr-controller__btns.svelte-1cgfpn0 {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
}

.rr-controller__btns.svelte-1cgfpn0 button.svelte-1cgfpn0 {
    width: 32px;
    height: 32px;
    display: flex;
    padding: 0;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    border-radius: 50%;
    cursor: pointer;
}

.rr-controller__btns.svelte-1cgfpn0 button.active.svelte-1cgfpn0 {
    color: #fff;
    background: rgb(73, 80, 246);
}

.switch.svelte-a6h7w7 {
    height: 1em;
    display: flex;
    align-items: center;
}

.switch.svelte-a6h7w7 input[type='checkbox'].svelte-a6h7w7 {
    position: absolute;
    opacity: 0;
}

.switch.svelte-a6h7w7 label.svelte-a6h7w7 {
    width: 2em;
    height: 1em;
    position: relative;
    cursor: pointer;
    display: block;
}

.label.svelte-a6h7w7 {
    margin: 0 8px;
    color: black
}

.rr-controller__btns.svelte-1cgfpn0 button.svelte-1cgfpn0 {
    width: 32px;
    height: 32px;
    display: flex;
    padding: 0;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    border-radius: 50%;
    cursor: pointer;
}

.switch input[type='checkbox']:checked+label.svelte-a6h7w7:before {
    background: rgb(73, 80, 246);
}

.switch.svelte-a6h7w7 label.svelte-a6h7w7:before {
    content: '';
    position: absolute;
    width: 2em;
    height: 1em;
    left: 0.1em;
    transition: background 0.1s ease;
    background: rgba(73, 80, 246, 0.5);
    border-radius: 50px;
}

.switch input[type='checkbox']:checked+label.svelte-a6h7w7:after {
    animation: switch-on 0.2s ease-out;
    left: 1.1em;
}

.switch.svelte-a6h7w7 label.svelte-a6h7w7:after {
    content: '';
    position: absolute;
    width: 1em;
    height: 1em;
    border-radius: 50px;
    left: 0;
    transition: all 0.2s ease;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
    background: #fcfff4;
    animation: switch-off 0.2s ease-out;
    z-index: 2;
}

</style>

<template lang="html">
<div id="root"  >
  <div id="iframe" v-loading="mobileLoding" element-loading-text="正在回溯" style="background:#eee;width:350px;height:707px" >

  </div>

  <div class="rr-controller svelte-1cgfpn0" style="padding:20px;">

      <div class="rr-timeline svelte-1cgfpn0"><span class="rr-timeline__time svelte-1cgfpn0">{{time}}</span>
          <div class="rr-progress svelte-1cgfpn0">
              <div class="rr-progress__step svelte-1cgfpn0" style="width: 0%;"></div>
              <div class="rr-progress__handler svelte-1cgfpn0" :style="{ 'left': jindu+'%'}"></div>
          </div>
          <span class="rr-timeline__time svelte-1cgfpn0">{{totalTime}}</span></div>
      <div class="rr-controller__btns svelte-1cgfpn0">
          <!-- <button class="svelte-1cgfpn0">
              <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16">
                  <path d="M170.65984 896l0-768 640 384zM644.66944 512l-388.66944-233.32864 0 466.65728z"></path>
              </svg>
          </button>
          <button class="svelte-1cgfpn0">1x</button>
          <button class="svelte-1cgfpn0 active">2x</button>
          <button class="svelte-1cgfpn0">4x</button>
          <button class="svelte-1cgfpn0">8x</button>
          <div class="switch svelte-a6h7w7">
              <input type="checkbox" id="skip" class="svelte-a6h7w7">
              <label for="skip" class="svelte-a6h7w7"></label> <span class="label svelte-a6h7w7">skip inactive</span></div> -->

      </div>
  </div>
</div>

</template>

<script>

export default {
  name: 'controller',
  data: function () {
    return {
      jindu: 0,
      time: null,
      totalTime: null,
      interval: null,
      mobileLoding: false
    }
  },
  created: function () {

  },
  methods: {
    start: function () {
      this.mobileLoding = true
    },
    play: function (events) {
      if (this.interval) {
        clearInterval(this.interval)
      }

      let _this = this

      let pay = document.getElementById('iframe')

      pay.innerHTML = ''
      const options = {
        speed: 2,
        root: pay,
        skipInactive: true
      }
      const replayer = new rrweb.Replayer(events, options)
      replayer.on('start', function () {
        _this.mobileLoding = false
        _this.$emit('onStart')
      })

      replayer.on('resize', function (e) {
        var root = document.getElementById('iframe')
        root.style.width = e.width + 'px'
        root.style.height = (e.height) + 'px'
        console.log('width:' + e.width + ' height:' + e.height)
      })

      replayer.play()

      this.interval = setInterval(function () {
        var offset = replayer.getMetaData()
        const currentTime = replayer.timer.timeOffset + replayer.getTimeOffset()

        _this.jindu = parseInt(currentTime / offset.totalTime * 100)

        let t = _this.formatTime(currentTime)
        _this.time = t
        _this.totalTime = _this.formatTime(offset.totalTime)
        console.log(currentTime + '============>' + t)
      }, 500)

      replayer.on('finish', function () {
        _this.$emit('onFinish')
      })
    },
    formatTime: function (ms) {
      const SECOND = 1000
      const MINUTE = 60 * SECOND
      const HOUR = 60 * MINUTE

      if (ms <= 0) {
        return '00:00'
      }
      const hour = Math.floor(ms / HOUR)
      ms = ms % HOUR
      const minute = Math.floor(ms / MINUTE)
      ms = ms % MINUTE
      const second = Math.floor(ms / SECOND)
      if (hour) {
        return hour + ':' + minute + ':' + second
      }
      return minute + ':' + second
    }
  }

}

</script>
